import {
  IsOptional,
  IsDate,
  IsArray,
  IsNotEmpty,
  ArrayMinSize,
} from "class-validator";

import { IAdapterBacklogRulesSummaryAction } from "./adapter-backlog-rules-summary-action.interface";

export class AdapterBacklogRulesSummaryActionDto implements IAdapterBacklogRulesSummaryAction {
  [s: string]: any;

  @IsOptional()
  @IsDate()
  start_date?: Date;

  @IsNotEmpty()
  @IsArray()
  @ArrayMinSize(1)
  rule_ids: string[];
}
